import { useRouter } from 'next/router';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Button from 'epn-ui/umd/dist/components/Button';
import useI18n from '@i18n';

import routes from '@config/routes.json';

import styles from './styles.module.scss';
import { IReviewModalProps } from '../interfaces';

const ReviewModal: React.FC<IReviewModalProps> = ({ formData }) => {
    const { t, locale } = useI18n('Placements');
    const router = useRouter();

    const onClose = (): Promise<boolean> => router.push(`/${locale}${routes.placements.list}`);

    return (
        <Dialog
            open
            title={<p className="text-center">{t('Traffic Sources is under inspection')}</p>}
            onCancel={onClose}
            footer={null}
            size="sm"
        >
            <p className={styles.url}>{formData?.url}</p>
            <p className="font-normal text-blueGray-500 text-[14px]">
                {t('Verification takes ≈ 4-5 hours. The status can be seen in Traffic Sources')}
            </p>
            <Button className="w-full mt-6" onClick={onClose} type="primary">
                {t('Go to Traffic Sources')}
            </Button>
        </Dialog>
    );
};

export default ReviewModal;
